<template>
<div class="header-bar">
  <!-- <div class="col-xs-10 col-sm-10 col-md-11 col-lg-12 float-Right padding-left-0Perc padding-right-0Perc margin-Top-5Perc"> -->
    <div class="row">
      <div class="col-xs-11 col-sm-11 col-md-11 col-lg-12 margin-Top-5Perc width float-Right admin-Panel-Padding font-size-2vw admin-Panel-BG text-align-left padding-right-0Perc">
        {{title}}
      </div>  
    </div> 
  <!-- </div> -->
</div>

</template>

<script>
export default {
  name: 'Profile-Header-Bar',
  data: function () {
    return {
      title: 'My Profile'
    }
  }
}
</script>
<style scoped>
.margin-Top-12Perc{
  margin-Top:12%;
}
.margin-left-4Perc{
  margin-left:4%
}

.margin-right-4Perc{
  margin-right:4%
}
.float-Right
{
	float: right;
}
.padding-left-0Perc{
  padding-left:0%;
}
.padding-right-0Perc{
  padding-right:0% !important;
}
.margin-Top-5Perc{
 margin-top:5%;
}
.admin-Panel-BG
{
  background-color: #f39c12;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 2vw;
}
.text-align-left
{
  text-align: left;
}
.width
{
  width: 96%;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/ProfileHeaderBar.vue